<template>
  <span>
    <v-btn
      icon
      color="green"
      @click="tenta_avvio_consegna"
      v-if="consegna.stato == 0"
      :small="small"
    >
      <v-icon>mdi-truck-delivery</v-icon>
    </v-btn>

    <v-dialog v-model="dialog_avvia" width="400" v-if="consegna.stato == 0">
      <v-card>
        <v-card-title>Attenzione</v-card-title>
        <v-card-text>
          <p>Il mezzo di consegna non si trova in azienda ...</p>
          <v-btn
            outlined
            color="blue"
            class="my-2"
            @click="programma_consegna()"
            :loading="loading_programma_consegna"
            >Non è ancora arrivato</v-btn
          >
          <v-btn outlined color="green" class="my-2" @click="avvia_consegna()"
            >è già partito</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_mezzo_offline"
      width="500"
      v-if="consegna.stato == 0"
    >
      <v-card>
        <v-card-title>Attenzione</v-card-title>
        <v-card-text>
          <p>Il mezzo di consegna risulta Offline ...</p>
          <v-btn
            outlined
            color="green"
            class="my-2 mx-1"
            @click="avvia_consegna()"
            >Imposta Comunque</v-btn
          >
          <v-btn
            outlined
            color="purple"
            class="my-2 mx-1"
            @click="archivia_consegna()"
            >Archivia</v-btn
          >
          <v-btn
            text
            color="grey"
            class="my-2 mx-1"
            @click="dialog_mezzo_offline = false"
            >Annulla</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-btn
      icon
      color="amber"
      v-if="consegna.stato == 1"
      @click="dialog_termina = true"
      :small="small"
    >
      <v-icon>mdi-truck-check</v-icon>
    </v-btn>
    <v-dialog v-model="dialog_termina" v-if="consegna.stato == 1" width="400">
      <v-card>
        <v-card-title class="amber--text"> Termina Consegna </v-card-title>
        <v-card-text> La consegna verrà terminata. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="green"
            @click="termina_consegna()"
            :loading="loading_termina"
          >
            <v-icon class="mr-2">mdi-truck-chek</v-icon>
            Termina
          </v-btn>
          <v-btn text color="grey" @click="dialog_termina = false"
            >Annulla</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
      icon
      color="purple"
      @click="dialog_archivia = true"
      v-if="consegna.stato == 2 && !consegna.archiviata"
      :small="small"
    >
      <v-icon>mdi-package-down</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialog_archivia"
      v-if="consegna.stato == 2 && !consegna.archiviata"
      width="400"
    >
      <v-card>
        <v-card-title class="purple--text"> Archivia Consegna </v-card-title>
        <v-card-text> La consegna verrà archiviata. </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined color="purple" @click="archivia_consegna()">
            <v-icon class="mr-2">mdi-package-down</v-icon>
            Archivia
          </v-btn>
          <v-btn text color="grey" @click="dialog_archivia = false"
            >Annulla</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import consegna_element_mixin from "../mixin/consegna_element_mixin";
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
  },
  name: "AvviaConsegnaButton",
  mixins: [consegna_element_mixin],
};
</script>